import React, { useEffect } from "react";
import { withErrorBoundary } from "@sentry/react";

const ChunkErrorFallback = ({ error }) => {
  useEffect(() => {
    if (
      error.message &&
      (error.message.includes("Loading chunk") ||
        error.message.includes("Failed to fetch dynamically imported module"))
    ) {
      window.location.reload();
    }
  }, [error]);

  return <div>Loading...</div>;
};

const ChunkErrorBoundary = ({ children }) => {
  return children;
};

export default withErrorBoundary(ChunkErrorBoundary, {
  fallback: ChunkErrorFallback,
  onError: (error) => {
    console.error("Chunk loading error:", error);
  },
});
